export const MMAXIMUM_DISTANCE_SEARCH_SPACES = 2000;
export const MAX_DISTANCE_THRESHOLD = 1.5;
export const DEFAULT_MAP_COORDINATES = {
  lat: 19.4115,
  lng: -99.1737,
};
